import * as tslib_1 from "tslib";
import * as pages from '../actions/pages.actions';
import { getNewTtl } from '../../core/helpers/date';
import * as auth from '../../auth/actions/auth.actions';
var initialState = {
    error: null,
    loading: false,
    pages: [],
    pagesTtl: null
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case pages.GET:
            return tslib_1.__assign({}, state, { loading: true });
        case pages.GET_SKIPPED:
            return tslib_1.__assign({}, state, { loading: false });
        case pages.GET_SUCCESS:
            return tslib_1.__assign({}, state, { pages: action.payload, loading: false, pagesTtl: getNewTtl() });
        case pages.GET_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload, loading: false });
        case auth.LOGOUT:
            return initialState;
        default:
            return state;
    }
}
// State Selectors
export var isLoading = function (state) { return state.loading; };
export var getPages = function (state) { return state.pages; };
export var getError = function (state) { return state.error; };
export var isPagesTtlExpired = function (state) { return state.pagesTtl === null || (state.pagesTtl < new Date()); };
